import { useState } from "react";
import { toast } from "sonner";
import { api, abs, money, errMsg } from "../lib/api";
import { DigitalDelivery } from "./DigitalDelivery";

export const OrderDetails = ({ order: initial, token }) => {
  const [order, setOrder] = useState(initial);
  const [busy, setBusy] = useState(false);
  const regenerate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/orders/${order.id}/regenerate-links`, null, { params: token ? { t: token } : {} });
      setOrder(data);
      toast.success("Fresh download links generated and emailed");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const a = order.shipping_address;
  return (
    <div className="grid gap-12 lg:grid-cols-12" data-testid="order-details">
      <div className="lg:col-span-7 space-y-10">
        {order.digital_items?.length > 0 && (
          <section>
            <div className="eyebrow mb-4">Your digital works</div>
            <DigitalDelivery items={order.digital_items} onRegenerate={regenerate} regenerating={busy} />
          </section>
        )}
        {a && (
          <section className="wb-card p-6" data-testid="order-shipping-address">
            <div className="eyebrow mb-3">Shipping to</div>
            <p className="text-sm leading-relaxed">
              {a.name}<br />{a.line1}{a.line2 && <>, {a.line2}</>}<br />{a.postal_code} {a.city}{a.state && `, ${a.state}`}<br />{a.country}
            </p>
            <p className="mt-3 text-xs muted">Status: <span className="gold uppercase tracking-widest" data-testid="order-fulfilment-status">{order.status === "shipped" ? "Shipped" : "Preparing for shipment"}</span></p>
          </section>
        )}
      </div>
      <aside className="lg:col-span-5 wb-card p-8 h-fit">
        <div className="flex items-baseline justify-between">
          <div className="eyebrow">Order</div>
          <span className="font-mono text-xs uppercase tracking-widest gold" data-testid="order-status">{order.status}</span>
        </div>
        <div className="font-display text-3xl mt-2" data-testid="order-number">{order.order_number}</div>
        <div className="mt-1 text-xs muted">{order.email}</div>
        <div className="mt-8 space-y-4">
          {order.items.map((i) => (
            <div key={i.product_id} className="flex items-center gap-4">
              {i.image_url && <img src={abs(i.image_url)} alt="" className="h-14 w-14 object-cover" />}
              <div className="flex-1 text-sm">{i.title} <span className="muted">× {i.quantity}</span></div>
              <div className="font-mono text-sm">{money(i.price * i.quantity)}</div>
            </div>
          ))}
        </div>
        <div className="mt-8 space-y-2 border-t wb-line pt-6 text-sm">
          <div className="flex justify-between muted"><span>Subtotal</span><span className="font-mono">{money(order.subtotal)}</span></div>
          <div className="flex justify-between muted"><span>Shipping</span><span className="font-mono" data-testid="order-shipping-total">{money(order.shipping_total)}</span></div>
          <div className="flex justify-between pt-2 text-base"><span>Total</span><span className="font-mono gold" data-testid="order-total">{money(order.amount_paid ?? order.total)} USD</span></div>
        </div>
      </aside>
    </div>
  );
};
